import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-save-icon',
  templateUrl: './general-save.component.html'
})
export class GeneralSaveComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
